import axios from 'axios';
import { getCookie } from '@/utils/cookies';

const $host = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    apikey: import.meta.env.VITE_API_KEY,
  },
});

const $authHost = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
    apikey: import.meta.env.VITE_API_KEY,
  },
});

$authHost.interceptors.request.use((config) => {
  // Проверяем, есть ли токен в заголовках запроса
  const requestToken = config.headers?.usertoken;
  if (requestToken) {
    // Если токен передан в запросе - используем его
    return config;
  } else {
    // Если токена нет в запросе - берем из localStorage
    config.headers.set('usertoken', getCookie('user_token'));
    return config;
  }
});

export { $host, $authHost };
